module.exports = __webpack_public_path__ + "media/top/about_room-df412153.svg";